import { CodeTypeSelector } from 'components/secondaryMarket/productSearch/codeSearch/CodeTypeSelector';
import { Switch } from 'components/shared/Switch/Switch';
import { FC, useCallback } from 'react';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
import type { ProductCodeType } from 'state/secondaryMarket/productSearch';

import { FlexRowGroup } from './RowGroup';
import { SectionTitle, TabForm } from './TabForm';

interface SecondaryMarketTabFormProps {
  onClose: () => void;
  defaultProductSearchCodeType: ProductCodeType;
  onProductSearchTypeChanged: (value: ProductCodeType) => void;

  isInternalUser?: boolean;
  closeTabWhenLiveTradeCpOrderIsPlacedActivated: boolean;

  onCloseTabWhenLiveTradeCpOrderIsPlacedChanged: (value: boolean) => void;
}

export const SecondaryMarketTabForm: FC<SecondaryMarketTabFormProps> = ({
  onClose,
  defaultProductSearchCodeType,
  onProductSearchTypeChanged,
  isInternalUser = false,
  closeTabWhenLiveTradeCpOrderIsPlacedActivated,
  onCloseTabWhenLiveTradeCpOrderIsPlacedChanged,
}) => {
  const onDefaultCodeTypeChanged = useCallback(
    (value: string) => {
      logAnalytics.trackEvent('User preferences', 'Set secondary market product search default code type', value);
      return onProductSearchTypeChanged(value as ProductCodeType);
    },
    [onProductSearchTypeChanged],
  );

  return (
    <TabForm labelKey="userPreferencesForm.secondaryMarket.label" onClose={onClose}>
      {isInternalUser && (
        <>
          <SectionTitle labelKey="userPreferencesForm.defaultValues.label" />
          <FlexRowGroup labelKey="userPreferencesForm.productSearchCodeTypes.label" isFirst labelWidth={50}>
            <CodeTypeSelector
              value={defaultProductSearchCodeType}
              onValueChanged={onDefaultCodeTypeChanged}
              isInternalUser={isInternalUser}
              fullWidth
            />
          </FlexRowGroup>
        </>
      )}

      <FlexRowGroup
        labelKey="userPreferencesForm.closeTabWhenLiveTradeCpOrderIsPlacedActivated.label"
        className="d-flex justify-content-end align-items-center"
        isFirst={false}
        labelWidth={50}
      >
        <Switch
          id="closeTabWhenLiveTradeCpOrderIsPlacedActivated"
          value={closeTabWhenLiveTradeCpOrderIsPlacedActivated}
          onToggleSwitch={onCloseTabWhenLiveTradeCpOrderIsPlacedChanged}
        />
      </FlexRowGroup>
    </TabForm>
  );
};

SecondaryMarketTabForm.displayName = 'SecondaryMarketTabForm';
